'use strict';

import { Entity } from '../Entity';

export class IndSpap extends Entity {
  protected spapId;

  protected indId;

  protected spapMemberId;

  protected spapGroupId;

  protected spapRxbin;

  protected spapPlanName;

  protected spapNote;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.spapId = data.spapId;

    this.indId = data.indId;

    this.spapMemberId = data.spapMemberId;

    this.spapGroupId = data.spapGroupId;

    this.spapRxbin = data.spapRxbin;

    this.spapPlanName = data.spapPlanName;

    this.spapNote = data.spapNote;
  }

  public getSpapId() {
    return this.spapId;
  }

  public setSpapId(spapId) {
    this.spapId = spapId;

    return this;
  }

  public getIndId() {
    return this.indId;
  }

  public setIndId(indId) {
    this.indId = indId;

    return this;
  }

  public getSpapMemberId() {
    return this.spapMemberId;
  }

  public setSpapMemberId(spapMemberId) {
    this.spapMemberId = spapMemberId;

    return this;
  }

  public getSpapGroupId() {
    return this.spapGroupId;
  }

  public setSpapGroupId(spapGroupId) {
    this.spapGroupId = spapGroupId;

    return this;
  }

  public getSpapRxbin() {
    return this.spapRxbin;
  }

  public setSpapRxbin(spapRxbin) {
    this.spapRxbin = spapRxbin;

    return this;
  }

  public getSpapPlanName() {
    return this.spapPlanName;
  }

  public setSpapPlanName(spapPlanName) {
    this.spapPlanName = spapPlanName;

    return this;
  }

  public getSpapNote() {
    return this.spapNote;
  }

  public setSpapNote(spapNote) {
    this.spapNote = spapNote;

    return this;
  }
}
